

export default {
  namespaced: true,
  state: {
    amwayPayAccount: {
      accountNumber: "",
      bank: "",
      customerId: "",
      id: "",
      methodKey: "",
      registeredAt: "",
      status: ""
    },
    amwayPayAccountStoreId: "cp_amwaybank",
    amwayPayAccountClientKey: "",

    amwayPayCard: {
      cardCompany: "",
      cardName: "",
      cardNumber: "",
      cardType: "",
      customerId: "",
      id: "",
      methodKey: "",
      registeredAt: "",
      status: ""
    },
    installmentPlan: 0,
    amwayPayCardStoreId: "cp_amwaypay",
    amwayPayCardClientKey: "",

    selectedParty: 0, // 0: Master, 1: Sub
    masterName: "",
    subName: "",
  },
  mutations: {
    reset(state) {
      state.amwayPayAccount = {
        accountNumber: "",
          bank: "",
          customerId: "",
          id: "",
          methodKey: "",
          registeredAt: "",
          status: ""
      };
      state.amwayPayAccountStoreId = "cp_amwaybank";
      state.amwayPayAccountClientKey = "";

      state.amwayPayCard = {
        cardCompany: "",
          cardName: "",
          cardNumber: "",
          cardType: "",
          customerId: "",
          id: "",
          methodKey: "",
          registeredAt: "",
          status: ""
      };
      state.installmentPlan = 0;
      state.amwayPayCardStoreId = "cp_amwaypay";
      state.amwayPayCardClientKey = "";
    },
    resetAmwayPay(state) {
      state.amwayPayAccount = {
        accountNumber: "",
          bank: "",
          customerId: "",
          id: "",
          methodKey: "",
          registeredAt: "",
          status: ""
      };
      
      state.amwayPayCard = {
        cardCompany: "",
          cardName: "",
          cardNumber: "",
          cardType: "",
          customerId: "",
          id: "",
          methodKey: "",
          registeredAt: "",
          status: ""
      };
      state.installmentPlan = 0;
    },
    selectAmwayPayAccount(state, value = {}) {
      state.amwayPayAccount = value;
    },
    updateAmwayPayAccountStoreId(state, value = "") {
      state.amwayPayAccountStoreId = value;
    },
    selectAmwayPayCard(state, value = {}) {
      state.amwayPayCard = value;
    },
    updateAmwayPayCardStoreId(state, value = "") {
      state.amwayPayCardStoreId = value;
    },
    updateAmwayPayAccountClientKey(state, value = "") {
      state.amwayPayAccountClientKey = value;
    },
    updateAmwayPayCardClientKey(state, value = "") {
      state.amwayPayCardClientKey = value;
    },
    updateAmwayPayInstallmentPlan(state, value = 0) {
      state.installmentPlan = value;
    },
    updateSelectedParty(state, value = 0) {
      state.selectedParty = value;
    },
    updateMasterName(state, value = '') {
      state.masterName = value;
    },
    updateSubName(state, value = '') {
      state.subName = value;
    }
  },
  getters: {
    selectedAmwayPayAccount: state => state.amwayPayAccount,
    selectedAmwayPayCard: state => state.amwayPayCard,
    currentAmwayPayAccountStoreId: state => state.amwayPayAccountStoreId,
    currentAmwayPayCardStoreId: state => state.amwayPayCardStoreId,
    currentAmwayPayAccountClientKey: state => state.amwayPayAccountClientKey,
    currentAmwayPayCardClientKey: state => state.amwayPayCardClientKey,
    amwayPayInstallmentPlan: state => state.installmentPlan,
    selectedParty: state => state.selectedParty,
    currentMasterName: state => state.masterName,
    currentSubName: state => state.subName,
  },
};
